import getAlertingTourSteps from './alerting.steps';

export default getAlertingTourSteps;
